module.exports = __webpack_public_path__ + "static/media/1 04 hvete.f2914e99.mp3";